import { Sizes } from "@jsq/ds/styles";
import { VerificationStatus } from "../types";
/**
 * Available verification status options for bank accounts
 */
export const VERIFICATION_OPTIONS: { value: VerificationStatus; label: string }[] = [
  { value: "VERIFIED", label: "Verified" },
  { value: "UNVERIFIED", label: "Unverified" },
];

/**
 * Default provider capability ID for global FundRecs configuration.
 * This represents the "global" capability that applies to all providers.
 * Note: This is now optional in ConfigurationInput - backend defaults to 0.
 */
export const GLOBAL_PROVIDER_CAPABILITY_ID = 0;

/**
 * Reusable style constants for field containers and rows
 */
export const FIELD_CONTAINER_STYLE = {
  display: "flex",
  flexDirection: "column" as const,
  gap: Sizes.XS,
};

export const FIELD_ROW_STYLE = {
  display: "flex",
  gap: Sizes.MD,
  width: "100%",
};
